module.exports = __webpack_public_path__ + "frontend/static/media/menarabic22.5962e7bf.png";